import { FC } from "react";
import { Outlet } from "react-router-dom";

const MachineLayout: FC = () => (
  <div style={styles.container}>
    <Outlet />
    <div style={styles.footer}>
      <p style={styles.footerText}>
        ©{new Date().getFullYear()} Powered by{" "}
        <a
          style={styles.footerLink}
          href="https://techpartners.asia/"
          target="_blank"
          rel="noreferrer"
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#333333";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#666666";
          }}
        >
          "Tech partners" LLC
        </a>
      </p>
    </div>
  </div>
);

const styles = {
  container: {
    position: "relative" as const,
    height: "100vh",
    width: "100%",
    backgroundColor: "#110703",
    display: "flex" as const,
    justifyContent: "center" as const,
    alignItems: "center" as const,
    overflow: "auto" as const,
  },
  footer: {
    position: "fixed" as const,
    bottom: 40,
    left: "50%",
    color: "white",
    transform: "translateX(-50%)",
    zIndex: 10,
    textAlign: "center" as const,
  },
  footerText: {
    fontSize: "0.875rem",
    margin: 0,
    lineHeight: 1.5,
  },
  footerLink: {
    cursor: "pointer" as const,
    color: "white",
    textDecoration: "none" as const,
    transition: "color 0.2s ease",
  },
};

export default MachineLayout;
